<template>
  <div class="quiz__tips">
    <header>
      <h2>{{$t('quiz.list[19].title')}}</h2>
    </header>

    <div class="tips__list">
      <div class="tip">
        <img :src="`${mediaBaseUrl}quiz/tips/check.svg`" alt="">
        {{$t('quiz.list[19].tips[0]')}}
      </div>
      <div class="tip">
        <img :src="`${mediaBaseUrl}quiz/tips/check.svg`" alt="">
        {{$t('quiz.list[19].tips[1]')}}
      </div>
      <div class="tip">
        <img :src="`${mediaBaseUrl}quiz/tips/check.svg`" alt="">
        {{$t('quiz.list[19].tips[2]')}}
      </div>
      <div class="tip">
        <img :src="`${mediaBaseUrl}quiz/tips/check.svg`" alt="">
        {{$t('quiz.list[19].tips[3]')}}
      </div>
      <div class="tip">
        <img :src="`${mediaBaseUrl}quiz/tips/check.svg`" alt="">
        {{$t('quiz.list[19].tips[4]')}}
      </div>
    </div>

    <img :src="`${mediaBaseUrl}quiz/covers/${gender}/users-bg.png`" alt="" class="bg" @load="$emit('imageLoaded')">
  </div>
</template>

<script>
export default {
  name: "quiz-tips",
  inject: ["mediaBaseUrl"],
  props: ["gender"],
}
</script>
